import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewBuildsLandingPageComponent } from './new-builds-landing-page.component';
import { RouterModule, Routes } from '@angular/router';
import { CanActivateGuard } from '../../modules/can-activate.guard';
import { ReactiveFormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NewBuildsLearnMoreComponent } from '../new-build-learn-more/new-builds-learn-more.component';
import { DialogModule } from 'primeng/dialog';

const routes: Routes = [
  /*{
    path: 'new-builds',
    component: NewBuildsLandingPageComponent,
    canActivate: [CanActivateGuard],
    data: { title: 'New Railcar Builds Page' },
  },*/
];
@NgModule({
  declarations: [NewBuildsLandingPageComponent, NewBuildsLearnMoreComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    TabViewModule,
    ProgressSpinnerModule,
    DialogModule,
  ],
  exports: [NewBuildsLandingPageComponent, NewBuildsLearnMoreComponent],
})
export class NewBuildsLandingPageModule {}
